// import Guardian from './Guardian';

export default {
  // component: Guardian,
  priority: 550,
  notShow:true,
  permissions: [
    "ShowLiveClockingsMenu",
    "LastClockingsMenu",
    "SecurityRequestsMenu",
    "DeviceSituationsMenu",
  ],
  name: app.translate("routes.home.guardian.Guardian"),
  icon: "security",
  drawer: true,
  description: `در این ماژول شما میتوانید انوا غذاهای مورد نظر، زمان ارائه وعده های غذایی،‌ سلف و برنامه غذایی سازمان خود را مشخص نمایید که بر اساس آن پرسنل بتوانند همانند فرایند درخواست مرخصی و ماموریت اقدام به ثبت رزرو غذا نمایند و پس از آن می توانید آمار دقیقی از تعداد و نوع غذاهایی که باید ارائه شود داشته باشید.
لازم به ذکر است هدف این ماژول صرفا ارائه آمار تعدادی رزروهای انجام شده می باشد و هزینه غذاها و کسر آن از پرسنل و ... در آن لحاظ نشده است.`,
};
